import { GetUnauthenticatedProviderAppointmentTypesResponse } from './getUnauthenticatedProviderAppointmentTypesResponse';

const locationList = new Array(2).fill(undefined).map((item, index) => ({
  id: `location${index}`,
  facilityName: `Facility Name ${index}`,
  friendlyLocationName: `Friendly Name ${index}`,
  locationPhoneNumber: '555-555-5555',
  streetAddress1: '123 Fourth Street',
  streetAddress2: 'Suite 56',
  city: 'Marshfield',
  state: 'WI',
  zip: '54449',
}));

const appointmentTypeList = new Array(4).fill(undefined).map((item, index) => ({
  id: `apptType${index}`,
  name: `Appointment Type ${index}`,
  description: `Value ${index} - A short description goes here.  Text should be at a maximum of 100 characters.`,
  bornBeforeDate: `01-01-2025`,
  bornAfterDate: `01-01-1825`,
  requireComment: false,
  locationList: locationList,
}));

const mockData = {
  appointmentTypeList: appointmentTypeList,
};

export const GetUnauthenticatedProviderAppointmentTypesServiceMock: GetUnauthenticatedProviderAppointmentTypesResponse =
  {
    data: mockData,
    succeeded: true,
  };
